const ErrorPage = () => {
  return (
    <div className='text-2xl flex text-center justify-center bg-slate-300 text-slate-800 font-bold h-screen w-full items-center'>
        <img src="https://parcely.freshdesk.com/assets/cdn/portal/images/no-results.png" alt="nothing" />
        ...Nothing to Show on the route
    </div>
  )
}

export default ErrorPage
